import { render, staticRenderFns } from "./FreelanceImporter.vue?vue&type=template&id=74bc669a"
import script from "./FreelanceImporter.vue?vue&type=script&lang=js"
export * from "./FreelanceImporter.vue?vue&type=script&lang=js"
import style0 from "./FreelanceImporter.vue?vue&type=style&index=0&id=74bc669a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports